import { Result } from "@praha/byethrow"
import { createServerFn } from "@tanstack/react-start"
import {
  savePushSubscription as savePushSubscriptionService,
  deletePushSubscription as deletePushSubscriptionService,
} from "@apps/gwservice/push-subscriptions"
import type { SavePushSubscriptionInput } from "@apps/gwservice/push-subscriptions"
import { ctx } from "@mylaunch/utils/logs"
import { withAuth } from "~/features/auth/server/auth"
import { getRequestHeaders } from "@tanstack/react-start/server"
import { installationIdFromHeaders } from "~/server/installation-id"

type ClientPushEventInput = {
  event: string
  name?: string
  message?: string
  userAgent?: string
  endpoint?: string
  permission?: string
  stage?: string
  outcome?: string
  elapsedMs?: number
}

export const logClientPushEvent = createServerFn({
  method: "POST",
})
  .inputValidator((data: ClientPushEventInput) => data)
  .handler(({ data }) =>
    Result.try({
      try: async () => {
        const { event, name, message, userAgent, endpoint, permission, stage, outcome, elapsedMs } = data
        ctx({ event, name, userAgent, endpoint, permission, stage, outcome, elapsedMs })
        if (message) ctx({ errorMessage: message })
      },
      catch: () => undefined,
    }),
  )

export const savePushSubscription = createServerFn({
  method: "POST",
})
  .inputValidator((data: SavePushSubscriptionInput) => data)
  .handler(({ data }) =>
    Result.try({
      try: async () => {
        await withAuth(savePushSubscriptionService)({
          ...data,
          installationId: installationIdFromHeaders(getRequestHeaders()),
        })
      },
      catch: (e) => {
        ctx({ errorMessage: e instanceof Error ? e.message : String(e) })
        return "unexpected server error"
      },
    }),
  )

export const deletePushSubscription = createServerFn({
  method: "POST",
})
  .inputValidator((data: { endpoint: string }) => data)
  .handler(({ data }) =>
    Result.try({
      try: async () => {
        await withAuth(deletePushSubscriptionService)(data)
      },
      catch: (e) => {
        ctx({ errorMessage: e instanceof Error ? e.message : String(e) })
        return "unexpected server error"
      },
    }),
  )
